import { FormBuilder, FormGroup } from '@angular/forms';
import { TipoFirmante } from '../../envios/models/tipo-firmante';

export interface FormularioGrupoBorrador {
  idNombreFormulario: number;
  nombre: string;
  obligatorio: boolean;
  valorOpcionSeleccionadaPorDefecto: string;
  firmante: TipoFirmante;
}

export interface ActualizarFormularioGrupoBorradorPatch {
  nombre?: string;
  obligatorio?: boolean;
  valorOpcionSeleccionadaPorDefecto?: string;
}

export function buildFormularioGrupoBorradorGroup(
  fb: FormBuilder,
  borrador: FormularioGrupoBorrador
): FormGroup {
  return fb.group({
    idNombreFormulario: [borrador.idNombreFormulario],
    nombre: [borrador.nombre],
    obligatorio: [borrador.obligatorio],
    valorOpcionSeleccionadaPorDefecto: [borrador.valorOpcionSeleccionadaPorDefecto],
    firmante: [borrador.firmante],
  });
}

export function readFormularioGrupoBorrador(row: FormGroup): FormularioGrupoBorrador {
  const firmante = row.get('firmante')?.value as TipoFirmante;
  return {
    idNombreFormulario: row.get('idNombreFormulario')?.value,
    nombre: row.get('nombre')?.value ?? '',
    obligatorio: row.get('obligatorio')?.value ?? false,
    valorOpcionSeleccionadaPorDefecto: row.get('valorOpcionSeleccionadaPorDefecto')?.value ?? '',
    firmante,
  };
}
